// How a sent shift reads to the dispatcher in the publish modal's published
// list. Derived from the Knack SMS status plus what happened this session.
export const sentStatuses = Object.freeze({
  PUBLISHED: 'published',
  PUBLISHED_NO_NOTIFICATIONS: 'published_no_notifications',
  TEXTED: 'texted',
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
})

export const NO_NOTIFICATIONS_ICON = 'notifications_off'

export const NO_NOTIFICATIONS_TOOLTIP =
  'Phone notifications are off. The shift is still visible when they open MyShifts.'

// Icons and hues follow the dispatch board's assignment tile so the two read
// the same. `sortRank` puts the rows that need the dispatcher first.
export const sentStatusDisplays = Object.freeze({
  [sentStatuses.DECLINED]: {
    label: 'Declined',
    icon: 'warning',
    chipColor: 'deep-orange lighten-5',
    textColor: 'deep-orange darken-4',
    sortRank: 0,
  },
  [sentStatuses.PUBLISHED_NO_NOTIFICATIONS]: {
    label: 'Published',
    icon: NO_NOTIFICATIONS_ICON,
    chipColor: 'purple lighten-5',
    textColor: 'purple darken-2',
    sortRank: 1,
  },
  [sentStatuses.PUBLISHED]: {
    label: 'Published',
    icon: 'notifications',
    chipColor: 'blue lighten-5',
    textColor: 'blue darken-3',
    sortRank: 2,
  },
  [sentStatuses.TEXTED]: {
    label: 'Texted',
    icon: 'phone_forwarded',
    chipColor: 'amber lighten-4',
    textColor: 'brown darken-3',
    sortRank: 3,
  },
  [sentStatuses.ACCEPTED]: {
    label: 'Accepted',
    icon: 'done',
    chipColor: 'green lighten-5',
    textColor: 'green darken-3',
    sortRank: 4,
  },
})
